export const TaskStatus = {
    ON_MODERATION: 1,
    NEW: 2,
    IN_WORK: 3,
    AWAITING_APPROVE: 4,
    DONE: 5,
    CANCELED: 6,
    DRAFT: 7,
    REJECTED: 8,
    ON_PAYMENT: 9,
    SYSTEM_MODERATION: 10,
} as const;

export type TaskStatusValue = (typeof TaskStatus)[keyof typeof TaskStatus];
